import React from "react";
import { plants } from "../data/siteData";

const Plants = () => {
  return (
    <>
      <style>{`
        .plants-section {
          background: linear-gradient(180deg, #f7f8ff 0%, #eef2ff 100%);
          padding: 70px 20px;
          font-family: Arial, sans-serif;
        }

        .plants-container {
          max-width: 1100px;
          margin: 0 auto;
        }

        .plants-title {
          text-align: center;
          font-size: 38px;
          margin-bottom: 60px;
          color: #2b234a;
          font-weight: 600;
        }

        .plant-card {
          display: flex;
          background: #ffffff;
          margin-bottom: 40px;
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 12px 32px rgba(39, 35, 60, 0.08);
          transition: 0.3s ease;
        }

        .plant-card:hover {
          transform: translateY(-6px);
        }

        .plant-card.reverse {
          flex-direction: row-reverse;
        }

        .plant-info {
          flex: 1;
          padding: 35px 40px;
        }

        .plant-info h2 {
          margin-bottom: 18px;
          color: #1f1840;
          font-size: 24px;
        }

        .plant-info p {
          margin: 8px 0;
          color: #4b4b6b;
          line-height: 1.6;
          font-size: 15px;
        }

        .plant-info strong {
          color: #2b234a;
        }

        .plant-info a {
          color: #667eea;
          text-decoration: none;
          font-weight: 500;
        }

        .plant-info a:hover {
          text-decoration: underline;
        }

        .plant-map {
          flex: 1;
          min-height: 350px;
        }

        .plant-map iframe {
          width: 100%;
          height: 100%;
          border: 0;
        }

        @media (max-width: 900px) {
          .plant-card {
            flex-direction: column;
          }

          .plant-card.reverse {
            flex-direction: column;
          }

          .plant-map {
            height: 250px;
          }
        }
      `}</style>

      <section className="plants-section">
        <div className="plants-container">
          <h1 className="plants-title">Our Plants</h1>

          {/* ✅ HEAD OFFICE CARD */}
          <div className="plant-card">
            <div className="plant-info">
              <h2>Head Office</h2>

              <p>
                Office No. 206 & 207<br />
                Sonigara Landmark, Chatrapati Chowk<br />
                Dynasty Society, Kaspate Wasti<br />
                Wakad, Pimpri Chinchwad<br />
                Pune, Maharashtra - 411057
              </p>

            
              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:info@shaktirmc.com">
                  info@shaktirmc.com
                </a>
              </p>
            </div>

            <div className="plant-map">
              <iframe
                src="https://www.google.com/maps?q=Sonigara+Landmark+Wakad+Pune&output=embed"
                title="Head Office Location"
                loading="lazy"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          {/* ✅ OTHER PLANTS (Dynamic from data) */}
          
        </div>
      </section>
    </>
  );
};

export default Plants;